import React from "react";
import { Icon } from "../../Common/Icons/LucideIcons";
import { FloatingIconButton } from "./__styles__/ChatToggleButton";

export type ChatToggleButtonProps = {
  onClick: () => void;
  isOpen?: boolean;
};

const ChatToggleButton = ({
  onClick,
  isOpen = false,
}: ChatToggleButtonProps) => {
  return (
    <FloatingIconButton
      type="button"
      onClick={onClick}
      aria-label={isOpen ? "Close AI Assistant" : "Open AI Assistant"}
    >
      <Icon iconName="sparkles" color="contentPrimaryInverted" size={16} />
    </FloatingIconButton>
  );
};

export default ChatToggleButton;
